import LoadingPageOverlay from '@components/common/LoadingPageOverlay';
import { StalledLoadPage } from '../../pages/ErrorPages';
import { useStalledAfter } from '@hooks/useStalledAfter';
import useAuth, { AuthContextType } from '@contexts/useAuth/useAuth';
import { Navigate, Outlet } from 'react-router';
export const Protected = ({ fallbackElement }: { fallbackElement?: JSX.Element }) => {
  const { user, isLoadingUser } = useAuth() as AuthContextType;
  /*
   * TV1-2369 — the auth check has no unhappy path of its own. If it never
   * settles, this loader spins forever with nothing to click and nothing thrown
   * for `ErrorBoundary` to catch. After 15s of no progress, say so and offer a
   * reload.
   */
  const stalled = useStalledAfter( isLoadingUser );

  if ( isLoadingUser && stalled ) return <StalledLoadPage />;

  return (
    <>
      {isLoadingUser ? (
        <LoadingPageOverlay>
          <div style={{ height: '100vh' }}></div>
        </LoadingPageOverlay>
      ) : user ? (
        <Outlet />
      ) : fallbackElement ? (
        fallbackElement
      ) : (
        <Navigate to="/auth" />
      )}
    </>
  );
};
export const Public = ({ fallbackElement }: { fallbackElement?: JSX.Element }) => {
  const { user } = useAuth() as AuthContextType;
  if ( user ) {
    // user is not authenticated
    if ( fallbackElement ) {
      return fallbackElement;
    } else {
      return <Navigate to="/" replace={true}/>;
    }
  }
  return <Outlet />;
};


